import { render, staticRenderFns } from "./BoxOuterWidth.vue?vue&type=template&id=bc907af2&"
import script from "./BoxOuterWidth.vue?vue&type=script&lang=ts&"
export * from "./BoxOuterWidth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports